export default __webpack_public_path__ + "static/media/portal.a7875ade.svg";